import classNames from "classnames";
import styles from "./new-assessment-body/NewAssessmentBody.module.css";

export const ExamineesHeader = ({
    isNew,
    allowCreateNew,
    allowExisting = true,
    onClickNew,
    onClickExisting
}: ExamineesHeaderProps): JSX.Element => {
    const containerClasses = classNames("is-flex", "is-flex-direction-column", "is-justify-content-center", "mt-4");
    const tabsClasses = classNames("is-flex", "is-flex-direction-row", "is-justify-content-center");

    const active = classNames(styles.active, "is-size-6", "px-5");
    const inactive = classNames(styles.inactive, "is-size-6", "px-5");

    return (
        <div className={containerClasses}>
            <div className={tabsClasses}>
                {allowCreateNew && (
                    <a
                        className={isNew ? active : inactive}
                        onClick={() => {
                            onClickNew?.();
                        }}
                    >
                        New Examinee
                    </a>
                )}
                {allowExisting && (
                    <a
                        className={!isNew ? active : inactive}
                        onClick={() => {
                            onClickExisting?.();
                        }}
                    >
                        Existing Examinee
                    </a>
                )}
            </div>
        </div>
    );
};

interface ExamineesHeaderProps {
    isNew: boolean;
    allowCreateNew: boolean;
    allowExisting?: boolean;
    onClickNew?: () => void;
    onClickExisting?: () => void;
}
